import React from 'react';
import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, Select, SelectChangeEvent, MenuItem, Autocomplete, Checkbox, FormControlLabel } from '@mui/material';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

// Sample users list
const usersList = [
  { label: 'Select All Users', id: 'all' },
  { label: 'John Doe', id: '1' },
  { label: 'Jane Smith', id: '2' },
  { label: 'Michael Scott', id: '3' },
  { label: 'Pam Beesly', id: '4' },
];

export default function AddNotification({ open, onClose, setOpen }: ModalProps) {
  const [autoCompleteOpen, setAutoCompleteOpen] = React.useState(true);
  const [selectedUsers, setSelectedUsers] = React.useState<typeof usersList>([]);
  const [type, setType] = React.useState('default');
  const [template, seTemplate] = React.useState('default');

  const handleUsersChange = (event: any, value: typeof usersList) => {
    const isSelectAllClicked = value.some((user) => user.id === 'all');

    if (isSelectAllClicked) {
      const isAllSelected = selectedUsers.length === usersList.length - 1;

      if (isAllSelected) {
        // Uncheck all
        setSelectedUsers([]);
      } else {
        // Select all (excluding "Select All" option itself)
        const allUsers = usersList.filter((user) => user.id !== 'all');
        setSelectedUsers(allUsers);
      }
    } else {
      setSelectedUsers(value);
    }
  };

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };
  const handleTemplateChange = (event: SelectChangeEvent) => {
    seTemplate(event.target.value as string);
  };

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Notification</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>
          <form className="form" action="">
            <div className="gap_p">
              <div className="control_group w_100">
                <TextField
                  variant="outlined"
                  placeholder="Notification Title"
                  fullWidth
                  hiddenLabel
                />
              </div>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={usersList}
                value={selectedUsers}
                onChange={handleUsersChange}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onOpen={() => setAutoCompleteOpen(true)}
                onClose={() => setAutoCompleteOpen(false)}
                renderOption={(props, option, { selected }) => {
                  const isAllOption = option.id === 'all';
                  const isAllSelected = selectedUsers.length === usersList.length - 1; // exclude "Select All"

                  return (
                    <li {...props}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isAllOption ? isAllSelected : selected}
                            indeterminate={isAllOption && selectedUsers.length > 0 && !isAllSelected}
                          />
                        }
                        name="option"
                        label={option.label}
                      />
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Users" variant="outlined" />
                )}
              />
              <div className="control_group w_50">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Type</MenuItem>
                  <MenuItem value="broadcast">Broadcast</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                </Select>
              </div>
              <div className="control_group w_50">
                <Select
                  fullWidth
                  value={template}
                  onChange={handleTemplateChange}
                >
                  <MenuItem disabled value="default">Select Template</MenuItem>
                  <MenuItem value="1">Template 1</MenuItem>
                  <MenuItem value="2">Template 2</MenuItem>
                </Select>
              </div>
              <div className="control_group w_100">
                <TextField
                  variant="outlined"
                  placeholder="Notification Message"
                  fullWidth
                  hiddenLabel
                  multiline
                  maxRows={5}
                  minRows={5}
                />
              </div>
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
